(function () {
  var HERO_LAYOUT_MQ = '(min-width: 990px)';
  var MAX_PARALLAX_DEPTH = 24;
  var MAX_SCROLL_RATE = 0.12;

  function lockHeroViewportHeight() {
    var viewportHeight = window.innerHeight;
    document.documentElement.style.setProperty('--quadra-hero-vh', viewportHeight * 0.01 + 'px');
  }

  function initHeroViewportHeight() {
    lockHeroViewportHeight();

    window.addEventListener('orientationchange', function () {
      setTimeout(lockHeroViewportHeight, 150);
    });

    function onLayoutChange() {
      lockHeroViewportHeight();
    }

    var layoutMq = window.matchMedia(HERO_LAYOUT_MQ);
    var pointerMq = window.matchMedia('(pointer: coarse)');

    layoutMq.addEventListener('change', onLayoutChange);
    pointerMq.addEventListener('change', onLayoutChange);
  }

  initHeroViewportHeight();

  function scrollRateForDepth(depth) {
    return (depth / MAX_PARALLAX_DEPTH) * MAX_SCROLL_RATE;
  }

  function initParallax(hero) {
    var layers = hero.querySelectorAll('.quadra-hero__parallax');
    var targetNx = 0;
    var targetNy = 0;
    var curNx = 0;
    var curNy = 0;
    var ticking = false;
    var SMOOTH = 0.055;
    var coarsePointer = window.matchMedia('(pointer: coarse)').matches;

    function norm(clientX, clientY) {
      var w = window.innerWidth || 1;
      var h = window.innerHeight || 1;
      return {
        nx: (clientX / w - 0.5) * 2,
        ny: (clientY / h - 0.5) * 2,
      };
    }

    function applyLayers() {
      for (var i = 0; i < layers.length; i++) {
        var el = layers[i];
        var depth = parseFloat(el.getAttribute('data-depth') || '10');
        el.style.setProperty('--tx', String(curNx * depth));
        el.style.setProperty('--ty', String(curNy * depth));
      }
    }

    function step() {
      curNx += (targetNx - curNx) * SMOOTH;
      curNy += (targetNy - curNy) * SMOOTH;
      applyLayers();
      if (Math.abs(targetNx - curNx) > 0.0015 || Math.abs(targetNy - curNy) > 0.0015) {
        requestAnimationFrame(step);
      } else {
        curNx = targetNx;
        curNy = targetNy;
        applyLayers();
        ticking = false;
      }
    }

    function setTarget(clientX, clientY) {
      var p = norm(clientX, clientY);
      targetNx = p.nx;
      targetNy = p.ny;
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(step);
      }
    }

    function center() {
      targetNx = 0;
      targetNy = 0;
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(step);
      }
    }

    applyLayers();

    if (coarsePointer) {
      var scrollLayers = [];
      var scrollState = [];
      var SCROLL_LERP = 0.1;
      var scrollParallaxTicking = false;

      for (var j = 0; j < layers.length; j++) {
        var layerEl = layers[j];
        var layerDepth = parseFloat(layerEl.getAttribute('data-depth') || '10');
        scrollLayers.push(layerEl);
        scrollState.push({
          targetSy: 0,
          curSy: 0,
          rate: scrollRateForDepth(layerDepth),
        });
      }

      function updateScrollTargets() {
        var s = window.scrollY || window.pageYOffset || 0;
        for (var k = 0; k < scrollState.length; k++) {
          scrollState[k].targetSy = -s * scrollState[k].rate;
        }
        if (!scrollParallaxTicking) {
          scrollParallaxTicking = true;
          requestAnimationFrame(scrollParallaxStep);
        }
      }

      function scrollParallaxStep() {
        var stillMoving = false;
        for (var m = 0; m < scrollLayers.length; m++) {
          var state = scrollState[m];
          state.curSy += (state.targetSy - state.curSy) * SCROLL_LERP;
          scrollLayers[m].style.setProperty('--sy', state.curSy + 'px');
          if (Math.abs(state.targetSy - state.curSy) > 0.15) {
            stillMoving = true;
          } else {
            state.curSy = state.targetSy;
            scrollLayers[m].style.setProperty('--sy', state.curSy + 'px');
          }
        }
        if (stillMoving) {
          requestAnimationFrame(scrollParallaxStep);
        } else {
          scrollParallaxTicking = false;
        }
      }

      updateScrollTargets();
      window.addEventListener('scroll', updateScrollTargets, { passive: true });
      window.addEventListener('resize', updateScrollTargets, { passive: true });
      return;
    }

    window.addEventListener('mousemove', function (e) {
      setTarget(e.clientX, e.clientY);
    }, { passive: true });
    window.addEventListener('resize', center, { passive: true });
  }

  function initScrollNext(root) {
    var btn = root.querySelector('[data-quadra-hero-scroll-next]');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var section = root.closest('.shopify-section');
      if (!section) return;

      var next = section.nextElementSibling;
      while (next && !next.classList.contains('shopify-section')) {
        next = next.nextElementSibling;
      }
      if (!next) return;

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var headerHeight = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 0;
      var top =
        next.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0) - headerHeight;

      window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  }

  function initQuadraHero(root) {
    initScrollNext(root);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;
    initParallax(root);
  }

  document.querySelectorAll('[data-quadra-hero]').forEach(initQuadraHero);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-quadra-hero]');
    if (root) {
      lockHeroViewportHeight();
      initQuadraHero(root);
    }
  });
})();
